import axios from "axios";
import { camelize } from "./parsers";
import { getLocalLanguage } from "./locationHelpers";
import { getToken } from "./cookieHelpers";

const instance = axios.create({
  // withCredentials: true,
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    "X-Platform": "website",
  },
});

instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.params = { ...config.params, lang: getLocalLanguage() };

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (config) => {
    return Promise.resolve({
      ...config,
      data: camelize(config.data),
    });
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const nodeApiInstance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_NODE_API_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Platform": "website",
  },
});

nodeApiInstance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    config.params = { ...config.params, lang: getLocalLanguage() };

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

nodeApiInstance.interceptors.response.use(
  (config) => {
    return Promise.resolve({
      ...config,
      data: camelize(config.data),
    });
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default instance;
